
import { Component, Vue, Watch } from 'vue-property-decorator'
import { MemberVO, MemberIVO } from '@/views/biz/login/vo/MemberVO.vo'
import { MypageOVO } from '@/views/biz/mypage/vo/Mypage.vo'
import { MemoIVO } from '../omr/vo/Omr.vo';
import { CorrectAnswerOVO } from '@/views/biz/omr/vo/Omr.vo'
import axios from 'axios'
import ExplanationDialog from '@/components/ExplanationDialog.vue'
import ExplanationFormDialog from '@/components/ExplanationFormDialog.vue'

@Component({
  components: {ExplanationDialog, ExplanationFormDialog}
})
export default class Mypage extends Vue {
  member: MemberVO = {} as MemberVO;
  myExplanations: Array<MypageOVO> = [];
  explanationDialog = false;
  explanationFormDialog = false;
  currentExplanation = {} as MypageOVO;

  nicname = '';
  email = '';
  
  // 닉네임
  validNicnameForm = false;
  nicnameDialog = false;
  nicnameRule = [
    (v: string) => !!v || '닉네임을 입력해주세요.',
  ];

  // 이메일
  validEmailForm = false;
  emailDialog = false;
  emailRule = [
    (v: string) => !!v || '이메일을 입력해주세요.',
  ];

  // 비밀번호
  passwordStep = 1;
  passwordDialog = false;

  currentPassword = '';
  currentPasswordForm = false;
  currentPasswordRule = [
    (v: string) => !!v || '현재 비밀번호를 입력하세요.',
  ];

  changePasswordForm = false;
  changePassword1 = '';
  changePasswordRule1 = [
    (v: string) => !!v || '변경할 비밀번호를 입력하세요.',
    (v: string) => (v && /^(?=.*\d{1,10})(?=.*[a-zA-Z]{2,10}).{8,20}/.test(v) && v.length >= 8 && v.length <= 20) || '영문/숫자 조합(8자 이상 20자 이하)',
  ];
  changePassword2 = '';
  changePasswordRule2 = [
    (v: string) => !!v || '비밀번호 확인을 입력하세요.',
    (v: string) => (v && /^(?=.*\d{1,10})(?=.*[a-zA-Z]{2,10}).{8,20}/.test(v) && v.length >= 8 && v.length <= 20) || '영문/숫자 조합(8자 이상 20자 이하)',
  ];

  selectPhoto(): void {
    (this.$refs.mbrFile as HTMLElement).click()
  }

  // 이미지
  changeMbrPhoto(e): void {
    const formData = new FormData();
    formData.append("file", e.target.files[0])
    formData.append('fileType', 'users')
    axios.post('/common/upload-file', formData, {headers: {'Content-Type': 'multipart/form-data'}})
    .then(r => {
      const params = {} as MemberIVO;
      params.mbrPhotoNm = r.data.fileName;
      params.mbrPhotoNo = r.data.file.fmNo;
      params.mbrPhotoUri = r.data.file.fmUrl;
      axios.put('mypage/photo', params)
      .then(r=>{
        this.member.mbrPhotoUri = params.mbrPhotoUri;
      })
    })
  }

  // 닉네임 변경
  editNicname(): void {
    if(!this.validNicnameForm) {
      return;
    }
    
    axios.put('mypage/nicname', {mbrNic: this.nicname})
    .then(r=>{
      this.member.mbrNic = this.nicname;
      this.nicnameDialog = !this.nicnameDialog;
      this.$toast('변경되었어요');
    })
  }

  // 비밀번호 검증 다음 스텝
  nextStep(): void {
    if(!this.currentPasswordForm) return;

    const param: MemberIVO = {} as MemberIVO;
    param.mbrPwd = this.currentPassword;
    axios.post('mypage/validate/passsword', param)
    .then(r=>{
      if(r.data) {
        this.passwordStep++;
      } else {
        this.resetVariable();
      }
    })
  }

  // 비밀번호 변경
  changePassword(): void {
    if(!this.changePasswordForm) return;
    if(this.changePassword1 != this.changePassword2) {
      return this.$toast('비밀번호가 일치하지 않아요')
    }

    const param: MemberIVO = {} as MemberIVO;
    param.mbrPwd = this.changePassword1;
    axios.put('mypage/password', param)
    .then(r=>{
      this.$toast('변경되었어요');
      this.passwordDialog = false;
      this.resetVariable();
    })
  }

  // 초기화
  resetVariable() {
    this.passwordStep = 1;
    this.currentPassword = '';
    this.changePassword1 = '';
    this.changePassword2 = '';
    this.currentPasswordForm = false;
  }

  // 비밀번호 변경 다이얼로그 닫기
  closePasswordDialog(): void {
    this.resetVariable();
    this.passwordDialog = false;
  }

  // 비밀번호 수정
  updatePassword(): void {
    const param: MemberIVO = {} as MemberIVO;
    param.mbrPwd = this.changePassword1;

    axios.put('mypage/password', param)
    .then(() =>{
      this.$toast('변경됐어요')
    })
  }

  // 이메일 변경
  editEmail(): void {
    if(!this.validEmailForm) {
      return;
    }

    axios.put('mypage/email', {mbrEmail: this.email})
    .then(r=>{
      this.member.mbrEmail = this.email;
      this.emailDialog = !this.emailDialog;
      this.$toast('변경되었어요');
    })
  }

  // 풀이/메모 조회
  viewExplanation(item: MypageOVO): void {
    this.currentExplanation = item;
    this.explanationDialog = true;
  }

  @Watch('nicnameDialog')
  changeDialog(ev) {
    ev && (this.nicname = this.member.mbrNic);
  }

  @Watch('emailDialog')
  changeEmailDialog(ev) {
    ev && (this.email = this.member.mbrEmail);
  }

  created(): void {
    axios.get('member')
    .then(r => {
      if(r.data) {
        this.member = r.data;
      } else {
        this.member = {} as MemberVO;
      }
    })

    axios.get('mypage/explanations')
    .then(r=>{
      this.myExplanations = r.data;
    })
  }
}
